import StrikethroughIcon from '@carbon/icons/es/text--strikethrough/16';
import StrikethroughEditing from '@ckeditor/ckeditor5-basic-styles/src/strikethrough/strikethroughediting';
import { createCarbonIconPlugin } from './carbon-icon';

export const STRIKETHROUGH = 'strikethrough';
export const Strikethrough = createCarbonIconPlugin({
  name: 'Strikethrough',
  editing: StrikethroughEditing,
  uis: [
    {
      command: STRIKETHROUGH,
      icon: StrikethroughIcon,
      label: 'Strikethrough',
      keystroke: 'CTRL+SHIFT+X',
    },
  ],
});
